// Users allowed to see and change the admin only settings and controls.
export const ADMIN_EMAILS = ['admin@jdcservices.ca', 'iginla_99@hotmail.com']

export function isAdmin(userData) {
  return !!userData && ADMIN_EMAILS.includes(userData.email)
}

export function roundTo(n, digits = 0) {
  var multiplicator = Math.pow(10, digits)
  var roundedNumber = Math.round(n * multiplicator) / multiplicator
  return roundedNumber
}

export function formatThousands(number) {
  return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
